/* eslint-disable object-curly-newline */
/* eslint-disable object-curly-spacing */
/* eslint-disable */
import { connect, useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useState, useRef } from 'react';
import { BaseModal } from '../BaseModal';
import { ListTable } from '../../ListTable';
import styles from './POItemsModal.module.scss';
import inventoryAnalyticsServices from '../../../Services/Analytics Services/inventory-analytics.services';
import { AlertModal } from '../AlertModal';
import TransactionDetails from './TransactionDetails';
import {
	addCommas,
	getUnitConvertedQuantity,
	renderSalesWeightQty,
	renderSalesWeightUnit,
	getUnitConvertedUnit,
	useProductData,
} from '../../../Helpers';
import TxnHeader from './TxnHeader/TxnHeader';
import { Button } from '@/Components/ui/button';
import { Label } from '@/Components/ui/label';
import { Input } from '@/Components/ui/input';
import TotalContainer from './TotalContainer/TotalContainer';
import { modalActions } from '@/Actions';
import AssetGroupSelectionSummary from '@/Components/AssetSelector/AssetGroupSelectionSummary';
import moment from 'moment';
import useFeatureFlags from '@/Helpers/useFeatureFlags';
import { Upload, X } from 'lucide-react';

const ACTION_COLUMNS = [];

const COLMAP = {
	'Issued For': 'poItemName',
	'Product Name': 'productName',
	'UY Variant Id': 'uyId',
	'UY Id': 'uyId',
	'Category Name': 'id',
	'Sub Category': 'id',
	'SKU Code': 'id',
	Unit: 'unit',
	Dispatched: 'fulfilled',
	Received: 'storeFulfilled',
	Packaged: 'packaged',
	'Ordered Quantity': 'qty',
	'Standard PO Qty': 'generatedQty',
	'Returned Quantity': 'qty',
	'Used For': 'usedFor',
	Quantity: 'qty',
	Fulfilled: 'fulfilled',
	Returned: 'returned',
	'From Process': 'fromProcess',
	'PO Id': 'poId',
	'Item Price': 'id',
	'Discount %': 'id',
	'Item Sub Total': 'id',
	'Tax Percentage': 'id',
	'Item Tax': 'id',
	'Tax value': 'id',
	'Item Amount': 'id',
	'Last Purchase Rate 1': 'id',
	'Last Purchase Rate 2': 'id',
	'Last Purchase Rate 3': 'id',
	'Ordered Packs': 'orderedPacks',
	'Pack Size': 'packSize',
	'Packaging Name': 'packagingName',
	'Additional Charges': 'id',
};

const TABLE_COLUMNS = [];

// Columns to display for FMCG_PACKAGING subtype
const FMCG_PACKAGING_COLUMNS = [
	'UY Variant Id',
	'Product Name',
	'Category Name',
	'Sub Category',
	'SKU Code',
	'Ordered Packs',
	'Fulfilled',
	'Pack Size',
	'PO Id',
	'Packaging Name',
];

// Item-level freight & additional charges are captured only while creating a
// vendor PO, so these columns are shown only for vendor orders.
const VENDOR_ONLY_COLUMNS = [
	'Additional Charges',
	'Freight Vendor',
	'Freight Rate',
	'Freight Cost',
];

const SPECIAL_COLUMNS = [
	{
		title: 'S.No',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'UY Variant Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Product Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Unit',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SKU Code',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Quantity',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Ordered Quantity',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Recommended Quantity',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Standard PO Qty',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Returned Quantity',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Fulfilled',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Returned',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Packaged',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Dispatched',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Received',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'From Process',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'PO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Ordered Packs',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Pack Size',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Packaging Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Production Plan Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Last Purchase Rate 1',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Last Purchase Rate 2',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Last Purchase Rate 3',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Item Price',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Discount %',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Tax Percentage',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Tax value',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Total Item Amount',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Used For',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Additional Charges',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Freight Vendor',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Freight Rate',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Freight Cost',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Additional Charges',
		config: {
			type: 'DATA',
		},
	},
];

const baseUnits = ['gram', 'gm', 'g', 'oz', 'floz', 'ml'];

const POItemsModal = (props) => {
	const { show, data, toggleModal, toggleAlert } = props;
	const {
		items = [],
		previousPrice = {},
		heading = 'Purchase Order Items',
		excludedColumns,
		isApprove,
		warningText = false,
		advanceBill = false,
		pageType = '',
		assetGroupingSummaryData = {},
		showPdf,
		showTotal,
		showPoDetails = false,
		previewFile,
		hideItems = false,
		isAdvanceBill = false,
		ignorePdfState = false,
		txnHeader = {},
		showProductionPlanColumns = false,
		customColumns = [],
		poClosingData = {},
		docUploadMandatory = false,
		isVendorOrder = false,
		showOrderCount = false,
	} = data;

	const isCapex = String(data?.subType || '').toUpperCase() === 'CAPEX';

	// Whether this document may leave the screen. The caller decides (the Download
	// column and this viewer must agree); absent means allowed, so callers that do not
	// pass it are unaffected.
	// The preview is a native browser PDF viewer inside an iframe and it exposes no
	// per-button control - `#toolbar=0` is the only lever, so the whole viewer toolbar
	// (download, print, zoom, page nav) goes away when the doc is withheld. That hides
	// the affordance; it is not enforcement, since the base64 still reaches the client.
	const docSrc = (src) => {
		if (!src || data?.allowDocDownload !== false) return src;
		// The src is a data: URL, so it carries no fragment of its own to clash with.
		return `${src}#toolbar=0&navpanes=0`;
	};

	const isCMS =
		data?.type === 'CMS' ||
		data?.type === 2 ||
		String(data?.subType || '').toUpperCase() === 'CMS_INDENT';

	// 'Issued For' (the parent PO item) is shown for CMS work orders (e.g.
	// FMS_WORKORDER) but hidden for CMS_INDENT. subType arrives as a humanized
	// label ('Work Order') or the raw enum ('FMS_WORKORDER'/'WORK_ORDER'), so
	// normalise (strip non-letters) and match on 'WORKORDER'.
	const isWorkOrder = String(data?.subType || '')
		.toUpperCase()
		.replace(/[^A-Z]/g, '')
		.includes('WORKORDER');

	const cmsColumns = [
		{
			title: 'S.No',
			config: {
				type: 'DATA',
			},
		},
		...(isWorkOrder
			? [
				{
					title: 'Issued For',
					config: {
						type: 'DATA',
					},
				},
			]
			: []),
		{
			title: 'Product Name',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'SKU Code',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Unit',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Quantity',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Fulfilled',
			config: {
				type: 'DATA',
			},
		},
	];

	const [searchQuery, setSearchQuery] = useState('');
	const [checkedInvoiceBill, setCheckedInvoiceBill] = useState(false);
	const [pdfState, setPdfState] = useState('');
	const [poData, setPOData] = useState(null);
	const [creditNoteDoc, setCreditNoteDoc] = useState(null);
	const [uploadedDoc, setUploadedDoc] = useState(null);
	const fileInputRef = useRef(null);
	const products = useSelector((state) => state.form.ALL_PRODUCTS.data.LIST);
	const vendors = useSelector((state) => state.form.ALL_VENDORS.data.LIST);
	const dispatch = useDispatch();
	const { CAN_ORDER_IN_PACKS } = useFeatureFlags();
	// Map of chargeCode -> chargeName so item-level charges (stored as
	// { cond_type: <code>, cond_value: <amount> }) can show friendly names.
	const [chargeCodeNameMap, setChargeCodeNameMap] = useState({});

	useEffect(() => {
		// if (Array.isArray(products) && products?.length === 0) {
		useProductData(dispatch);
		// }
	}, []);

	useEffect(() => {
		(async () => {
			try {
				const response = await inventoryAnalyticsServices?.listAdditionalOrderCharges();
				if (response?.statusCode === 200 && response?.data) {
					const groups = Array.isArray(response?.data)
						? response?.data
						: [response?.data];
					const map = {};
					groups.forEach((g) => {
						const charges = Array.isArray(g?.charges)
							? g?.charges
							: Array.isArray(g)
								? g
								: [];
						charges.forEach((c) => {
							if (c?.chargeCode) map[c.chargeCode] = c?.chargeName;
						});
					});
					setChargeCodeNameMap(map);
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log(error);
			}
		})();
	}, []);

	useEffect(() => {
		if (poClosingData?.creditDocS3Location) {
			(async () => {
				const response = await inventoryAnalyticsServices.fetchS3Doc({
					docUrl: poClosingData?.creditDocS3Location,
				});
				if (response?.statusCode === 200) {
					setCreditNoteDoc(response?.data?.base64);
				}
			})();
		}
	}, [poClosingData?.creditDocS3Location]);

	const getPoById = async (poId) => {
		const response = await inventoryAnalyticsServices.fetchPo(Number(poId), isCMS ? { cmsIngredients: true } : {});
		if (response?.statusCode === 200) {
			return response?.data;
		}
		return null;
	};

	const fetchPdfData = async () => {
		try {
			const response = await inventoryAnalyticsServices.fetchInvTransDoc({
				req: {
					params: {
						transactionId: data?.id,
					},
				},
			});
			if (response?.statusCode === 200) {
				setPdfState(response?.data?.base64);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};
	const fetchPoPdfData = async () => {
		try {
			const response = await inventoryAnalyticsServices.fetchPoPdfDoc({
				req: {
					params: {
						orderId: data?.id,
					},
				},
			});
			if (response?.statusCode === 200) {
				setPdfState(response?.data?.base64);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	useEffect(() => {
		if (!previewFile) {
			if (
				data?.id &&
				(isApprove || poClosingData?.creditDocS3Location) &&
				data?.uploadedDoc
			) {
				fetchPdfData();
			}
			if (data?.id && !!data?.poURL) {
				fetchPoPdfData();
			}
		} else {
			setPdfState(previewFile);
		}
	}, [data?.id, data?.poURL, previewFile]);

	useEffect(async () => {
		if (show && data?.poId) {
			const t = await getPoById(data?.poId);
			setPOData(t ?? {});
		}
	}, [show, data?.poId]);

	const handleClose = () => {
		toggleModal(false, {});
		setPdfState('');
		setCheckedInvoiceBill(false);
		setSearchQuery('');
		setUploadedDoc(null);
	};

	const getRowHighlighted = (item) => {
		let orderQty = null;
		let approveQty = item?.extraData?.autoApproveQty;
		const poItem = poData?.items?.find((i) => {
			return item.variantId === i?.variantId;
		});
		const itemQty = poItem?.qty ?? item?.qty;
		orderQty = itemQty;
		if (baseUnits?.includes(item?.unit)) {
			orderQty = getUnitConvertedQuantity(
				itemQty,
				item?.unit,
				true,
				true
			);
			approveQty = getUnitConvertedQuantity(
				item?.extraData?.autoApproveQty,
				item?.unit,
				true,
				true
			);
		}
		if (item?.extraData) {
			if (item?.extraData?.manualRateUpdated) {
				return 'bg-red-100';
			}
			if (approveQty < orderQty) {
				return 'bg-red-100';
			}
		}
		return '';
	};

	const ITEMS = useMemo(() => {
		// CMS orders: the ingredient breakdown (ingredient name + parent 'poItemName'
		// + qty + sku) lives on poData.items (GET_PO with cmsIngredients:true), NOT on
		// the finished-product rows passed in `items`. Render those so ingredient names
		// are visible; fall back to `items` until poData loads.
		const baseItems =
			isCMS && Array.isArray(poData?.items) && poData.items.length
				? poData.items
				: items;
		const mapped = baseItems
			?.filter((item) => {
				const categoryId = item?.categoryId;
				const isAssetOrService = item?.assetId != null || item?.serviceId != null;
				if (!isCapex && !isAssetOrService && (!categoryId || categoryId === 0 || categoryId === '0')) {
					if (!isCMS) {
						return false;
					}
				}
				if (!searchQuery) {
					return true; // Return true for all items when searchQuery is empty
				}
				const poItemName = item?.extraData?.poItemName || '';
				return (
					item?.productName
						?.toLowerCase()
						?.includes(searchQuery?.toLowerCase()) ||
					poItemName
						?.toLowerCase()
						?.includes(searchQuery?.toLowerCase())
				);
			})
			?.map((ele, index) => {
				let id = ele?.variantId + '_' + ele?.poId;
				if (ele?.assetId) {
					id = ele?.assetId + '_' + ele?.id;
				}
				if (ele?.serviceId) {
					id = ele?.serviceId + '_' + ele?.id;
				}
				if (ele?.skuId) {
					id = ele?.skuId + '_' + ele?.parentSkuId;
				}
				if (ele?.packagingInfo) {
					id = ele?.id;
				}
				// CMS: the same ingredient variant can appear under multiple parent
				// PO items, so variantId+poId isn't unique — add the index to keep
				// each row's React key distinct.
				if (isCMS) {
					id = `${ele?.variantId}_${ele?.poId}_${index}`;
				}
				return {
					...ele,
					// CMS orders don't carry poItemName on the item itself; the parent
					// PO's item name comes from the cmsIngredients breakdown (poData,
					// fetched with cmsIngredients:true). Resolve it by variantId so the
					// 'PO Item Name' column isn't blank for CMS orders.
					poItemName:
						ele?.extraData?.poItemName ??
						poData?.items?.find(
							(poItem) => poItem?.variantId === ele?.variantId
						)?.extraData?.poItemName ??
						'-',
					packSize: ele?.packagingInfo?.packSize,
					orderedPacks: ele?.orderedPackQty,
					packagingName: ele?.packagingInfo?.packagingProductName
						? ele?.packagingInfo?.packagingProductName +
						' (' +
						ele?.packagingInfo?.packagingVariantName +
						')'
						: '-',
					uyId: ele?.id,
					id,
					rowStyles: !excludedColumns?.includes(
						'Recommended Quantity'
					)
						? getRowHighlighted(ele)
						: '',
				};
			});
		// CMS orders: sort by PO Item Name (then Product Name). Unresolved names
		// ('-'/blank) sort to the bottom. poItemName is resolved above from poData,
		// so this recomputes once the cmsIngredients response lands.
		if (isCMS && Array.isArray(mapped)) {
			const sortKey = (v) => {
				const s = String(v ?? '').trim();
				return !s || s === '-' ? '￿' : s.toLowerCase();
			};
			mapped.sort((a, b) => {
				const na = sortKey(a?.poItemName);
				const nb = sortKey(b?.poItemName);
				if (na !== nb) return na.localeCompare(nb, undefined, { numeric: true });
				return sortKey(a?.productName).localeCompare(
					sortKey(b?.productName),
					undefined,
					{ numeric: true }
				);
			});
		}
		return mapped;
	}, [items, searchQuery, poData, isCMS]);

	// Only surface the item-level "Additional Charges" column when at least one
	// item actually carries `conditions` (the backend contract).
	const hasItemCharges = useMemo(() => {
		return items?.some((it) => it?.extraData?.conditions?.length > 0);
	}, [items]);

	const getItemPackSize = (item, poItem) => {
		if (!item?.packagingInfo && !item?.packagingMappingId && !poItem?.packagingMappingId) {
			return 1;
		}
		return Number(
			item?.packagingInfo?.packSize ??
				item?.extraData?.packSize ??
				poItem?.extraData?.packSize ??
				1
		) || 1;
	};

	const getPackLabel = (item) => {
		const info = item?.packagingInfo;
		if (!info?.packagingProductName) return '';
		return `[${info.packagingProductName} ${info.packagingVariantName ?? ''} of ${info.packSize}pcs]`;
	};

	const SPECIAL_ITEMS = {
		'S.No': (itemId) => {
			const index = ITEMS.findIndex((item) => item.id === itemId);
			return index + 1;
		},
		'Issued For': (itemId, val) => {
			return val ?? '-';
		},
		'Product Name': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			// FMCG packaged items: same label as the PO PDF
			// -> "productName-variantName [packagingProduct packagingVariant of Npcs]"
			const packLabel = getPackLabel(item);
			if (packLabel) {
				return (
					<div>
						<p>
							{item?.productName +
								(item?.variantName != null ? '-' + item?.variantName : '') +
								' ' +
								packLabel}
						</p>
						<p>{item?.description ? item?.description : ''}</p>
					</div>
				);
			}
			return (
				<div>
					<p>
						{item?.productName +
							(item?.variantName
								? ' (' + item?.variantName + ')'
								: '')}
					</p>
					<p>{item?.description ? item?.description : ''}</p>
				</div>
			);
		},
		'UY Variant Id': (itemId, val) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			// CAPEX / asset / service me variant nahi hota -> uska UY id (assetId/serviceId) dikhao.
			if (isCapex || item?.assetId != null || item?.serviceId != null) {
				return item?.assetId ?? item?.serviceId ?? val ?? '-';
			}
			return item?.variantId ?? val ?? '-';
		},
		// CAPEX me column title 'UY Id' hota hai — wahi renderer (asset/service UY id).
		'UY Id': (itemId, val) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return val ?? '-';
		},

		'Sub Category': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return products?.find((product) => product?.id === item?.productId)
				?.subCategoryName
				? products?.find((product) => product?.id === item?.productId)
					?.subCategoryName
				: item?.subCategoryName ?? '-';
		},
		'SKU Code': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return item?.clientVariantId
				? item?.clientVariantId
				: products
					.find((product) => product?.id === item?.productId)
					?.variants?.find(
						(variant) => variant?.id === item?.variantId
					)?.clientVariantId ?? '-';
		},

		'Used For': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return (
				<div>
					<p>{item?.usedFor}</p>
				</div>
			);
		},
		'Additional Charges': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			// Backend contract: extraData.conditions [{ cond_type, cond_value }].
			// Fall back to the rich additionalCharges shape if present.
			const charges =
				item?.extraData?.conditions ??
				item?.extraData?.additionalCharges ??
				[];
			if (!charges?.length) {
				return '-';
			}
			const chargesTotal = charges.reduce(
				(sum, c) => sum + (Number(c?.cond_value ?? c?.price) || 0),
				0
			);
			return (
				<div className='flex flex-col gap-1 py-1'>
					{charges.map((c, i) => {
						const code = c?.cond_type ?? c?.chargeCode;
						const amount = c?.cond_value ?? c?.price;
						const name =
							c?.cond_name ||
							chargeCodeNameMap?.[code] ||
							c?.chargeName ||
							code;
						return (
							<div
								key={i}
								className='flex items-center justify-between gap-2 rounded-md border border-slate-200 bg-white px-2 py-1 shadow-sm'
							>
								<div className='flex min-w-0 flex-col text-left'>
									<span className='truncate text-[11px] font-semibold text-slate-700 leading-tight'>
										{name}
									</span>
									{code ? (
										<span className='text-[9px] font-medium uppercase tracking-wide text-slate-400 leading-tight'>
											{code}
										</span>
									) : null}
								</div>
								<span className='shrink-0 rounded bg-slate-100 px-2 py-0.5 text-[11px] font-bold text-slate-700'>
									₹{amount ?? 0}
								</span>
							</div>
						);
					})}
					{charges.length > 1 && (
						<div className='mt-0.5 flex items-center justify-between border-t border-slate-200 px-1 pt-1'>
							<span className='text-[9px] font-semibold uppercase tracking-wide text-slate-400'>
								Total
							</span>
							<span className='text-[11px] font-bold text-slate-800'>
								₹{chargesTotal}
							</span>
						</div>
					)}
				</div>
			);
		},
		'Recommended Quantity': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const salesWeight = item?.extraData?.manualRateUpdated || item?.extraData?.autoApproveQty == null
				? null
				: renderSalesWeightQty(item, item?.extraData?.autoApproveQty);
			if (salesWeight) return salesWeight;
			const autoApproveQty = baseUnits?.includes(item?.unit)
				? getUnitConvertedQuantity(
					item?.extraData?.autoApproveQty,
					item?.unit,
					true,
					true
				)
				: item?.extraData?.autoApproveQty;
			const value = item?.extraData?.manualRateUpdated
				? 'Manual Rate Updated'
				: autoApproveQty;
			return value ?? '-';
		},
		'Standard PO Qty': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			// New API shape: value lives in extraData.generateStandardPoQty.
			// Fall back to legacy top-level generatedQty for older POs.
			const generatedQty =
				item?.extraData?.generateStandardPoQty ?? item?.generatedQty;
			if (generatedQty === undefined || generatedQty === null) {
				return '-';
			}
			const salesWeight = renderSalesWeightQty(item, generatedQty);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					generatedQty,
					item?.unit,
					true,
					true
				);
			}
			return generatedQty;
		},
		Unit: (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const salesWeight = renderSalesWeightUnit(item);
			if (salesWeight) return salesWeight;
			const itemUnit = item?.unit;
			if (baseUnits?.includes(itemUnit)) {
				return getUnitConvertedUnit(item?.qty, itemUnit);
			}
			return itemUnit;
		},
		'Order Type': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return item?.orderType ?? item?.type ?? '-';
		},
		'Category Name': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return item?.categoryName ?? '-';
		},
		'Ordered Quantity': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const poItem = poData?.items?.find((i) => {
				return item.variantId === i?.variantId;
			});
			const itemQty = poItem?.qty ?? item?.qty;
			// FMCG packaged items: show ordered packs, same as the PO PDF (qty / packSize)
			const packSize = getItemPackSize(item, poItem);
			if (packSize > 1 && itemQty != null) {
				return +(Number(itemQty) / packSize).toFixed(3);
			}
			const salesWeight = renderSalesWeightQty(item, itemQty);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemQty,
					item?.unit,
					true,
					true
				);
			}
			return itemQty;
		},
		'Returned Quantity': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const itemQty = item?.qty;
			const salesWeight = renderSalesWeightQty(item, itemQty);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemQty,
					item?.unit,
					true,
					true
				);
			}
			return itemQty;
		},
		Quantity: (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const itemQty = item?.qty;
			const salesWeight = renderSalesWeightQty(item, itemQty);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemQty,
					item?.unit,
					true,
					true
				);
			}
			return itemQty;
		},
		Packaged: (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const itemPacked = item?.packaged;
			const salesWeight = renderSalesWeightQty(item, itemPacked);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemPacked,
					item?.unit,
					true,
					true
				);
			}
			return itemPacked;
		},
		Received: (itemId) => {
			const item = ITEMS?.find?.((poItem) => {
				return itemId === poItem?.id;
			});
			const poItem = poData?.items?.find?.((i) => {
				return item.variantId === i?.variantId;
			});
			const itemReceived = poItem ? item?.qty : item?.storeFulfilled;
			const salesWeight = renderSalesWeightQty(item, itemReceived);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemReceived,
					item?.unit,
					true,
					true
				);
			}
			return itemReceived;
		},
		Dispatched: (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const itemFulfilled = item?.fulfilled;
			const salesWeight = renderSalesWeightQty(item, itemFulfilled);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemFulfilled,
					item?.unit,
					true,
					true
				);
			}
			return itemFulfilled;
		},
		Fulfilled: (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const itemFulfilled = item?.fulfilled;
			const salesWeight = renderSalesWeightQty(item, itemFulfilled);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemFulfilled,
					item?.unit,
					true,
					true
				);
			}
			return itemFulfilled;
		},
		Returned: (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const itemReturned = item?.returned;
			const salesWeight = renderSalesWeightQty(item, itemReturned);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemReturned,
					item?.unit,
					true,
					true
				);
			}
			return itemReturned;
		},
		'From Process': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return item?.fromProcess ?? '-';
		},
		'PO Id': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return item?.poId ?? '-';
		},
		'Ordered Packs': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return item?.orderedPacks ?? '-';
		},
		'Pack Size': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return item?.packSize ?? '-';
		},
		'Packaging Name': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return item?.packagingName ?? '-';
		},
		'Production Plan Name': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			// return item?.poId ?? '-';
			return item?.clientPoId ?? '-';
		},
		'Total Item Amount': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return (
				`₹${addCommas(item?.totalValue ?? item?.finalAmount)}` ?? '-'
			);
		},
		'Item Price': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return `₹${item?.productCost ?? item?.price ?? '-'}`;
		},
		'Discount %': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return item?.discountPercentage ?? '-';
		},
		'Tax Percentage': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return `${item?.taxPercentage}%` ?? '-';
		},
		'Last Purchase Rate 1': (itemId) => {
			const variantId = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			})?.variantId;
			const previousPriceData = previousPrice[variantId]?.[0] ?? {};
			return Object.keys(previousPriceData)?.length > 0 ? (
				<div className='flex flex-col gap-1'>
					<span className='text-[14px] font-bold text-nowrap'>
						{previousPriceData?.productCost} Rs/
						{previousPriceData?.unit}
					</span>
					<div className='flex flex-col'>
						<span className='text-[10px] text-nowrap'>
							{moment(previousPriceData?.createdAt).format(
								'DD MMM YY'
							)}
						</span>
						<span className='text-[10px] text-nowrap'>
							{' '}
							{previousPriceData?.vendorName}
						</span>
					</div>
				</div>
			) : (
				'-'
			);
		},
		'Last Purchase Rate 2': (itemId) => {
			const variantId = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			})?.variantId;
			const previousPriceData = previousPrice[variantId]?.[1] ?? {};
			return Object.keys(previousPriceData)?.length > 0 ? (
				<div className='flex flex-col gap-1'>
					<span className='text-[14px] font-bold text-nowrap'>
						{previousPriceData?.productCost} Rs/
						{previousPriceData?.unit}
					</span>
					<div className='flex flex-col'>
						<span className='text-[10px] text-nowrap'>
							{moment(previousPriceData?.createdAt).format(
								'DD MMM YY'
							)}
						</span>
						<span className='text-[10px] text-nowrap'>
							{previousPriceData?.vendorName}
						</span>
					</div>
				</div>
			) : (
				'-'
			);
		},
		'Last Purchase Rate 3': (itemId) => {
			const variantId = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			})?.variantId;
			const previousPriceData = previousPrice[variantId]?.[2] ?? {};
			return Object.keys(previousPriceData)?.length > 0 ? (
				<div className='flex flex-col gap-1'>
					<span className='text-[14px] font-bold text-nowrap'>
						{previousPriceData?.productCost} Rs/
						{previousPriceData?.unit}
					</span>
					<div className='flex flex-col'>
						<span className='text-[10px] text-nowrap'>
							{moment(previousPriceData?.createdAt).format(
								'DD MMM YY'
							)}
						</span>
						<span className='text-[10px] text-nowrap'>
							{previousPriceData?.vendorName}
						</span>
					</div>
				</div>
			) : (
				'-'
			);
		},
		'Tax value': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			let itemQty = item?.qty;
			if (baseUnits?.includes(item?.unit)) {
				itemQty = getUnitConvertedUnit(itemQty, item?.unit);
			}
			// itemQty = getUnitConvertedQuantity(itemQty, item?.unit, true, true);
			let itemPrice = item?.price;
			if (item?.unit === 'gram' || item?.unit === 'ml') {
				itemPrice /= 1000;
			}
			if (item?.unit === 'oz') {
				itemPrice /= 16;
			}
			if (item?.unit === 'floz') {
				itemPrice /= 128;
			}
			const percentageValue =
				(itemPrice * itemQty * item?.taxPercentage) / 100;
			if (!item?.productTaxValue) {
				return `₹${addCommas(percentageValue)}`;
			}
			return `₹${addCommas(item?.productTaxValue)}` ?? '-';
		},
		'Freight Vendor': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const vendorId =
				item?.extraData?.vendorSelection?.vendorId ||
				item?.vendorSelection?.vendorId;
			const vendorName = vendors?.find((v) => v.id === vendorId)?.name;
			return (
				vendorName || '-'
			);
		},
		'Freight Rate': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return (
				item?.extraData?.vendorSelection?.vendorRate || '-'
			);
		},
		'Freight Cost': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const rate = item?.extraData?.vendorSelection?.vendorRate || 0;
			const poItem = poData?.items?.find((i) => {
				return item.variantId === i?.variantId;
			});
			let itemQty = poItem?.qty ?? item?.qty;

			if (baseUnits?.includes(item?.unit)) {
				itemQty = getUnitConvertedQuantity(itemQty, item?.unit, true, true);
			}

			return rate * itemQty ? `₹${addCommas(rate * itemQty)}` : '-';
		},
		'Additional Charges': (itemId) => {
			const item = ITEMS?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const charges = item?.extraData?.additionalCharges || item?.extraData?.conditions || item?.extraData?.charges || [];
			if (!Array.isArray(charges) || charges.length === 0) {
				return '-';
			}
			return (
				<div className='flex flex-col gap-1 text-[12px] text-left'>
					{charges.map((c, i) => {
						const name = c?.name || c?.type || c?.cond_name || c?.chargeName || c?.cond_type || c?.chargeCode || 'Charge';
						const value = c?.value !== undefined ? c?.value : (c?.price !== undefined ? c?.price : (c?.cond_value !== undefined ? c?.cond_value : 0));
						return (
							<div key={i} className='flex justify-between gap-2 text-nowrap'>
								<span>{name}:</span>
								<span className='font-semibold'>₹{addCommas(Number(value) || 0)}</span>
							</div>
						);
					})}
				</div>
			);
		},
	};

	const isDisabled = useMemo(() => {
		if (docUploadMandatory && !uploadedDoc) {
			return true;
		}
		if (advanceBill) {
			return !checkedInvoiceBill;
		}
		if (ignorePdfState) {
			return !checkedInvoiceBill;
		}
		return !pdfState || !checkedInvoiceBill;
	}, [pdfState, checkedInvoiceBill, advanceBill, ignorePdfState, docUploadMandatory, uploadedDoc]);

	const renderBtns = () => {
		return (
			isApprove && (
				<div className={styles['btn-container']}>
					<div className={styles['terms-conditions']}>
						{warningText ? (
							<Label
								className='text-red-600'
								htmlFor='termsCheckbox'
							>
								{data?.warningText}
							</Label>
						) : (
							<>
								<input
									id='termsCheckbox'
									className={styles.checkbox}
									type='checkbox'
									checked={checkedInvoiceBill}
									onClick={() => {
										setCheckedInvoiceBill(
											!checkedInvoiceBill
										);
									}}
								/>
								<Label htmlFor='termsCheckbox'>
									{data?.approvalText}
								</Label>
							</>
						)}
					</div>
					<div className={styles.btns}>
						<Button
							className='primary-btn flex-1'
							disabled={isDisabled}
							onClick={() => {
								if (pageType === 'vendors') {
									toggleAlert(true, {
										handleConfirm: (approveReason) => {
											props?.handleConfirm(
												data,
												approveReason,
												uploadedDoc,
												data?.prId
											);
											handleClose();
											toggleAlert(false, {});
										},
										heading: `Approve #${data?.clientPoId ??
											data?.clientTransactionId
											}`,
										confirmText: 'Approve',
										height: 'fit-content',
										width: '27.5rem',
										message: `Are you sure you want to approve #${data?.clientPoId ??
											data?.clientTransactionId
											}?`,
										colorReverse: true,
										rendererType: 'poItemsModal',
									});
									return;
								}
								props.handleConfirm(data);
								setCheckedInvoiceBill(false);
								setPdfState('');
							}}
						>
							Approve
						</Button>
						<Button
							className='flex-1'
							variant='destructive'
							onClick={() => {
								if (props.handleReject) {
									toggleAlert(true, {
										handleConfirm: (rejectionReason) => {
											props?.handleReject(
												data,
												rejectionReason,
												uploadedDoc,
												data?.prId
											);
											handleClose();
											toggleAlert(false, {});
										},
										heading: `Reject #${data?.clientPoId ??
											data?.clientTransactionId
											}`,
										takeInput: true,
										confirmText: 'Reject',
										height: 'fit-content',
										width: '27.5rem',
										message: 'Please Give reason to Reject',
										inputLabel: 'Enter Reason',
										colorReverse: true,
										rendererType: 'poItemsModal',
									});
									// props.handleReject(data);
								}
							}}
						>
							Reject
						</Button>
					</div>
				</div>
			)
		);
	};

	const calculatedData = useMemo(() => {
		let subTotal = 0;
		let totalTax = 0;
		let totalPrice = 0;
		let taxOnPackagingCharges = 0;
		let taxOnDeliveryCharges = 0;
		const additionalCharges = {};
		if (data?.packagingCharges) {
			taxOnPackagingCharges =
				data?.packagingCharges * (data?.packagingTaxPercentage / 100);
		}
		if (data?.deliveryCharges) {
			taxOnDeliveryCharges =
				data?.deliveryCharges * (data?.deliveryTaxPercentage / 100);
		}
		totalTax += taxOnDeliveryCharges + taxOnPackagingCharges;
		totalPrice +=
			data?.deliveryCharges +
			taxOnDeliveryCharges +
			(data?.packagingCharges + taxOnPackagingCharges);
		(data?.jsonData ?? data?.extraData)?.additionalCharges?.forEach(
			(ele) => {
				// eslint-disable-next-line no-prototype-builtins
				if (additionalCharges?.hasOwnProperty(ele?.type)) {
					additionalCharges[ele?.type] += Number(ele?.price)?.toFixed(
						2
					);
					additionalCharges[
						'Tax on ' + ele?.type + `(${ele?.taxPercentage}%)`
					] += Number(
						(ele?.price * ele?.taxPercentage) / 100
					)?.toFixed(2);
				} else {
					additionalCharges[ele?.type] = Number(ele?.price)?.toFixed(
						2
					);
					additionalCharges[
						'Tax on ' + ele?.type + `(${ele?.taxPercentage}%)`
					] = Number(
						(ele?.price * ele?.taxPercentage) / 100
					)?.toFixed(2);
				}
				totalTax += Number((ele?.price * ele?.taxPercentage) / 100);
				totalPrice += Number(
					ele?.price * (1 + ele?.taxPercentage / 100)
				);
			}
		);

		let itemAdditionalChargesTotal = 0;
		items?.forEach((ele) => {
			if (ele?.qty > 0) {
				if (ele?.finalValue) {
					const finalValue = Number(ele?.finalValue) || 0;
					const productTax = Number(ele?.productTaxValue) || 0;
					totalPrice += finalValue;
					subTotal += finalValue - productTax;
					totalTax += productTax;
				} else {
					const finalAmount = Number(ele?.finalAmount) || 0;
					const taxPct = Number(ele?.taxPercentage) || 0;
					const itemSubTotal = (1 + taxPct / 100) === 0
						? 0
						: finalAmount / (1 + taxPct / 100);
					const itemTax = finalAmount - itemSubTotal;
					if (finalAmount) totalPrice += finalAmount;
					subTotal += Number(ele?.subTotal) || itemSubTotal || 0;
					totalTax += Number(ele?.taxValue) || itemTax || 0;
				}
			}
			// ITEM-level additional charges (amount-only, no tax).
			(ele?.extraData?.conditions ?? ele?.extraData?.additionalCharges ?? [])?.forEach(
				(c) => {
					itemAdditionalChargesTotal +=
						Number(c?.cond_value ?? c?.price) || 0;
				}
			);
		});
		totalPrice += itemAdditionalChargesTotal;
		return {
			'Sub Total:': subTotal,
			'Packaging: ': data?.packagingCharges,
			'Tax On Packaging (18%): ': taxOnPackagingCharges,
			'Delivery: ': data?.deliveryCharges,
			'Tax On Delivery (18%): ': taxOnDeliveryCharges,
			'Additional Charges: ': additionalCharges,
			...(itemAdditionalChargesTotal
				? { 'Item Additional Charges: ': itemAdditionalChargesTotal }
				: {}),
			'Tax:':
				data?.taxType === 'STATE'
					? {
						SGST: (totalTax / 2)?.toFixed(2),
						CGST: (totalTax / 2)?.toFixed(2),
						Total: totalTax?.toFixed(2),
					}
					: {
						IGST: totalTax?.toFixed(2),
						Total: totalTax?.toFixed(2),
					},
			'Total Price: ': totalPrice,
		};
	}, [items]);

	const renderDiv = () => {
		return (
			docUploadMandatory && (
				<div className='flex items-center gap-3 px-1'>
					<div className='flex items-center gap-2'>
						<input
							ref={fileInputRef}
							type='file'
							accept='.pdf,.jpg,.jpeg,.png'
							className='hidden'
							onChange={(e) => {
								const file = e.target.files?.[0];
								if (file) {
									const reader = new FileReader();
									reader.onload = () => {
										setUploadedDoc(reader.result);
									};
									reader.readAsDataURL(file);
								}
							}}
						/>
						<Button
							variant='outline'
							className={`flex items-center gap-2 h-9 px-4 border rounded-xl transition-all font-medium text-sm ${uploadedDoc
								? 'text-[#3b82f6] border-[#3b82f6] bg-blue-50'
								: 'text-black border-[#e5e7eb] hover:bg-black/5 hover:border-black/20'
								}`}
							onClick={() => fileInputRef.current?.click()}
						>
							<Upload size={18} />
							{uploadedDoc ? 'File Selected ✓' : 'Upload Doc *'}
						</Button>
					</div>
					{!uploadedDoc && (
						<span className='text-xs font-semibold text-red-600 bg-red-50 border border-red-200 px-2 py-1 rounded'>
							Document upload is mandatory
						</span>
					)}
					{uploadedDoc && (
						<span
							className='text-xs cursor-pointer hover:underline font-bold bg-red-50 px-2 py-1 rounded'
							onClick={() => {
								setUploadedDoc(null);
								if (fileInputRef.current)
									fileInputRef.current.value = '';
							}}
						>
							<X size={18} />
						</span>
					)}
				</div>
			)
		);
	};

	return (
		<BaseModal
			open={show}
			heading={heading}
			handleClose={handleClose}
			showConfirm={false}
			renderBtns={renderBtns}
			width={data?.width ?? '60rem'}
			height={data?.height ?? '30rem'}
			wrapperClassName='!overflow-y-hidden'
		>
			<AlertModal type='poItemsModal' />
			{isAdvanceBill && <p className={styles.advance}>Advance Bill</p>}
			<div className={styles.root}>
				{showPdf && (
					<div className={styles.lhs}>
						{pdfState && creditNoteDoc ? (
							<>
								<div className='h-2/4 mb-[14px] relative'>
									<div className='absolute top-0 left-0 bg-slate-100 px-2 py-1 rounded-r-lg text-left text-red-800 font-bold text-md'>
										<span>Uploaded Invoice Doc</span>
									</div>
									<iframe
										className={styles.iframe}
										width='100%'
										height='100%'
										src={pdfState}
										title='PDF Rendered from Base64'
									/>
								</div>
								<div className='h-2/4 mb-[14px] relative'>
									<div className='absolute top-0 left-0 bg-slate-100 px-2 py-1 rounded-r-lg text-left text-red-800 font-bold text-md'>
										<span>Credit Doc</span>
									</div>
									<iframe
										className={styles.iframe}
										width='100%'
										height='100%'
										src={creditNoteDoc}
										title='PDF Rendered from Base64'
									/>
								</div>
							</>
						) : (
							<div className='h-full relative'>
								<div className='absolute top-0 left-0 bg-slate-100 px-2 py-1 rounded-r-lg text-left text-red-800 font-bold text-md'>
									<span>
										{data?.poURL
											? 'Generated DOC'
											: pdfState
												? 'Uploaded Invoice Doc'
												: 'Credit Doc'}
									</span>
								</div>
								<iframe
									className={styles.iframe}
									width='100%'
									height='100%'
									src={docSrc(pdfState || creditNoteDoc)}
									title='PDF Rendered from Base64'
								/>
							</div>
						)}
					</div>
				)}
				<div className={styles.rhs}>
					{txnHeader?.show && (
						<div className={styles.txn_header}>
							<TxnHeader
								heading={txnHeader?.heading}
								helper={txnHeader?.helper}
							/>
						</div>
					)}
					{showPoDetails && (
						<TransactionDetails
							transactionData={data?.transactionData}
						/>
					)}
					{!hideItems && (
						<div className={styles.items}>
							<Input
								value={searchQuery}
								onChange={(e) => {
									setSearchQuery(e?.target?.value);
								}}
								placeholder='Search Item'
								className='w-full'
							/>
							<div
								className={styles.list}
								style={{
									position: 'relative',
								}}
							>
								{poClosingData?.creditValue && (
									<p className=' text-left text-red-800 font-bold text-lg absolute top-1 left-2'>
										<span>Credit Note Amount: ₹</span>
										<span>
											{poClosingData?.creditValue}{' '}
											(Inclusive of Tax)
										</span>
									</p>
								)}
								<ListTable
									colMap={COLMAP}
									columns={TABLE_COLUMNS}
									fixedHeaderTop={0}
									data={ITEMS}
									exportFilename={heading
										?.split(' ')
										?.join('_')}
									showTotal
									extraTotals={showOrderCount ? [{
										label: 'Orders',
										value: new Set(ITEMS?.map((item) => item?.poId).filter((poId) => poId != null)).size,
									}] : []}
									actions={isCMS ? cmsColumns : [
										...SPECIAL_COLUMNS,
										...ACTION_COLUMNS,
									]
										// CAPEX me 'UY Variant Id' column ka title 'UY Id' dikhao.
										?.map((col) =>
											isCapex && col?.title === 'UY Variant Id'
												? { ...col, title: 'UY Id' }
												: col
										)
										?.filter((col) => {

											// For FMCG_PACKAGING subtype, only show specific columns
											if (data?.type === '5') {
												return FMCG_PACKAGING_COLUMNS?.includes(
													col?.title
												);
											}
											const defaultExluding = [
												'Order Type',
												...(isCapex ? ['Category Name', 'Sub Category'] : []),
											]?.filter((ele) => {
												return !customColumns?.includes(
													ele
												);
											});
											const canViewOrderInPacks =
												CAN_ORDER_IN_PACKS;
											if (!canViewOrderInPacks) {
												defaultExluding.push(
													'Ordered Packs',
													'Pack Size',
													'Packaging Name'
												);
											}
											// Freight & additional charges columns
											// are only relevant for vendor orders.
											if (!isVendorOrder) {
												defaultExluding.push(
													...VENDOR_ONLY_COLUMNS
												);
											}
											return ![
												...([
													...(excludedColumns ?? []),
													...defaultExluding,
												] ?? [
														'Fulfilled',
														'From Process',
														'PO Id',
														'Quantity',
													]),
												showProductionPlanColumns &&
												'Production Plan Name',
											]?.includes(col?.title);
										})}
									renderBtns={renderDiv}
									special={SPECIAL_ITEMS}
								/>
							</div>
						</div>
					)}
					{assetGroupingSummaryData?.groupedAssets && (
						<AssetGroupSelectionSummary
							extraData={assetGroupingSummaryData?.extraData}
							cartItems={assetGroupingSummaryData?.cartItems}
							groupedAssets={
								assetGroupingSummaryData?.groupedAssets
							}
						/>
					)}
					{showTotal && (
						<TotalContainer calculatedData={calculatedData} />
					)}
				</div>
			</div>
		</BaseModal>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state.modal.poItemsModal;
	return {
		show,
		data,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.togglePOItemsModal,
	toggleAlert: modalActions.toggleAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(POItemsModal);
